import {
    CABLE_LENGTH_IDS,
    PREMIUM_CHARGER_PNS,
} from '../components/common/constants';
import { IOrderDetails } from '../models/product-detail';

export const cableLengthHook = (orderState: IOrderDetails) => {
    if (
        orderState &&
        orderState.rightSelectedIds &&
        orderState.leftSelectedIds &&
        orderState.accessories
    ) {
        const containsRight = orderState.rightSelectedIds.some((r) =>
            CABLE_LENGTH_IDS.includes(r)
        );
        const containsLeft = orderState.leftSelectedIds.some((l) =>
            CABLE_LENGTH_IDS.includes(l)
        );
        const isPremiumCharger = orderState.accessories.some((acc) =>
            PREMIUM_CHARGER_PNS.includes(acc.partNumber)
        );
        if ((containsLeft || containsRight) && isPremiumCharger) {
            return true;
        }
        if (orderState.receivers && isPremiumCharger) {
            return orderState.receivers.some(
                (rec) => rec.cableLength === 4 || rec.cableLength === 5
            );
        }
        return false;
    }

    return false;
};
